import React, { useState } from 'react'
import { Box, IconButton, Tooltip, Typography, SxProps, Theme } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

interface Props {
  value: string
  textSx?: SxProps<Theme>
}

// Developer-tools-local copy control. Unlike the shared UI/Copy component, the icon button
// is always visible (not shown/hidden on hover) so copying never changes the row's available
// width — important here since token values wrap via word-break and a width change reflows the text.
export const CopyValue: React.FC<Props> = ({ value, textSx }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.85rem', color: '#4b2b5c', ...textSx }}>
        {value}
      </Typography>
      <Tooltip title={copied ? 'Copied!' : 'Copy'}>
        <IconButton size="small" onClick={handleCopy} aria-label={copied ? 'Copied' : 'Copy'} sx={{ p: 0.3, flexShrink: 0 }}>
          <ContentCopyIcon sx={{ fontSize: 14, color: '#a08fa8' }} />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
